import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import PageWrapper from '/components/page-wrapper'

import HelpText from '/help/account-management-password'
import { AppContext } from '/providers/app-context'

import Menu from '/components/account/nav-menu'
import PasswordAdmin from '/components/account/password'

const AccountManagementPassword = () => {

  
  const navigate = useNavigate()

  const { user } = useContext(AppContext)

  if (!user?.permissions.client_admin) navigate("../password")

  return (
    <PageWrapper title="Password Management" HelpText={HelpText} heading="Password Management" menu={<Menu user={user} />}>
      <div className='flex flex-col gap-5 overflow-y-auto'>
        <PasswordAdmin />
      </div>
    </PageWrapper>
  )
}

export default AccountManagementPassword